import { render, staticRenderFns } from "./CreditCheck.vue?vue&type=template&id=e12b5480&scoped=true"
import script from "./CreditCheck.vue?vue&type=script&lang=js"
export * from "./CreditCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12b5480",
  null
  
)

export default component.exports